<template>
    <div class="document__head p-1 pt-2">
        <div class="table-container">
            <table v-if="header_details" class="modern-table">
                <tbody>
                    <tr class="header-row data-row">
                        <td colspan="4">
                            <div class="d-flex">
                                {{ header_details.doc_name }}
                                <span class="ms-auto">
                                    <b-button v-show="enable_edit" @click="handleSave()" class="" size="sm" variant="success" style="padding-top: 1px; padding-bottom: 1px;">
                                        <i class="fas fa-save me-1"/>
                                        Save
                                    </b-button>
                                    <b-button v-show="enable_edit" @click="reset()" class="ms-1" size="sm" variant="secondary" style="padding-top: 1px; padding-bottom: 1px;">
                                        <i class="fas fa-times me-1"/>
                                        Cancel
                                    </b-button>

                                </span>
                                
                            </div>
                        </td>
                    </tr>

                    <tr class="data-row">
                        <td colspan="1" style="width: 100px; border-right: 1px solid rgb(193, 193, 193);" class="label">Name:</td>
                        <td colspan="3">{{ header_details.doc_description }}</td>
                    </tr>

                    <tr class="data-row">
                        <td class="label" style=" border-right: 1px solid rgb(193, 193, 193);">SOP No:</td>
                        <td :class="rowEditableClass">
                            <div v-if="enable_edit">
                                <b-form-input v-model="editable_data.sop_code" size="sm"></b-form-input>
                            </div>
                            <span v-else>
                                {{ header_details.sop_number }}
                            </span>
                        </td>
                        <td class="label" style="width: 120px; border-right: 1px solid rgb(193, 193, 193);  border-left: 1px solid rgb(193, 193, 193);">Effective Date:</td>
                        <td :class="rowEditableClass">
                            <div v-if="enable_edit" >
                                <b-form-input ref="effectiveInput" @focus="showPicker('effectiveInput')"  v-model="editable_data.effective_date" input-toggle="true" type="date" size="sm"></b-form-input>
                            </div>
                            <span v-else>
                                {{ editable_data.effective_date }}
                            </span>
                        </td>
                    </tr>

                    <tr class="data-row">
                        <td class="label" style=" border-right: 1px solid rgb(193, 193, 193);">Revision No:</td>
                        <td  :class="rowEditableClass">
                            <div v-if="enable_edit">
                                <b-form-input v-model="editable_data.revision_number" size="sm"></b-form-input>
                            </div>
                            <span v-else>
                                {{ header_details.revision_number }}
                            </span>
                        </td>
                        <td class="label" style=" border-right: 1px solid rgb(193, 193, 193); border-left: 1px solid rgb(193, 193, 193);">Supersedes:</td>
                        <td  :class="rowEditableClass">
                            <div v-if="enable_edit" >
                                <b-form-input v-model="editable_data.supersedes" input-toggle="true" size="sm"></b-form-input>
                            </div>
                            <span v-else>
                                {{ header_details.supersedes }}
                            </span>
                        </td>
                    </tr>

                    <tr class="data-row">
                        <td class="label" style=" border-right: 1px solid rgb(193, 193, 193);">Revise By:</td>
                        <td colspan="3" :class="rowEditableClass">
                            <div v-if="enable_edit" >
                                <b-form-input ref="reviseInput" @focus="showPicker('reviseInput')"  id="reviseDateThing" v-model="editable_data.revise_by_date" input-toggle="true" type="date" size="sm"></b-form-input>
                            </div>
                            <span v-else>
                                {{ header_details.revise_by_date }}
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <b-overlay :show="is_loading" no-wrap></b-overlay>
    </div>
</template>

<script>
//eslint-disable-next-line
import { isAfter, parseISO } from 'date-fns'
import { sopState, sopMethods } from '@/state/helpers';
export default {
    props:{
        header_details:{},
        revision_uid:{},
    },
    data:() => ({
        is_loading: false,
        editable_data:{
            revise_by_date: null,
            revision_number: null,
            effective_date: null,
            supersedes: null,
            sop_code: null,
        }
    }),
    watch:{
        enable_edit(){
            this.setEditableData();
        }
    },
    computed:{
        ...sopState,
        rowEditableClass(){
            return this.enable_edit ? 'edtiable-table-row' : '';
        },
        enable_edit(){
            return this.sop_data && this.sop_data.admin_override;
        }
    },
    methods:{
        ...sopMethods,
        showPicker(id){
            const inputElement = this.$refs[id].$el.showPicker();
            if (inputElement) {
                inputElement.click();
            }
        },
        setEditableData(){
            this.editable_data.revise_by_date = this.header_details.revise_by_date;
            this.editable_data.effective_date = this.header_details.effective_date;
            this.editable_data.revision_number = this.header_details.revision_number;
            this.editable_data.supersedes = this.header_details.supersedes;
            this.editable_data.sop_code = this.header_details.sop_number;
        },
        handleSave(){
            if (isAfter(parseISO(this.editable_data.effective_date), parseISO(this.editable_data.revise_by_date))) {
                this.$swal.fire(`Effective date can't be after the Revise date.`);
                return;
            }
            if (!this.editable_data.sop_code || !String(this.editable_data.sop_code).trim()) {
                this.$swal.fire(`SOP number can't be empty.`);
                return;
            }

            this.is_loading = true;
            let save_payload = {
                client_revision_id: this.revision_uid,
                effective_date: this.editable_data.effective_date,
                revise_date: this.editable_data.revise_by_date,
                revision_no: this.editable_data.revision_number,
                supersedes: this.editable_data.supersedes,
                sop_code: this.editable_data.sop_code
            }
            this.saveSopHeader(save_payload)
            .then(()=>{
                this.loadSopData(this.sop_data.id)
                .then(()=>{
                    this.is_loading = false;
                })
            })
            .catch((error)=>{
                let message = 'An error occured while saving';
                if (error && error.response && error.response.data && error.response.data.message) {
                    message = error.response.data.message;
                }
                this.$swal.fire(message);
                this.is_loading = false;
            })
        },
        reset(){
            this.setEditableData();
        }
    },
    mounted(){
        if(this.enable_edit){
            this.setEditableData();
        }
    },
}
</script>

<style scoped>
.table-container {
  width: 100%;
  height: 20rem;
  overflow-x: auto;
  border-radius: 4px; /* Rounded outer borders */
  border: 1px solid rgb(132, 132, 132);
}

.table-container .modern-table {
  width: 100%;
  border-collapse: separate; /* Separate border for inner cells */
  border-spacing: 0; /* Remove default spacing */
  background-color: #ffffff;
}

.table-container .header-row {
  background-color: #f8f9fa;
  font-weight: bold;
}

.table-container .description-row {
  background-color: #f8f9fa;
}

.table-container .data-row:nth-child(odd) {
  background-color: #f2f3f4;
}

.table-container .label {
  font-weight: bold;
  padding-right: 1rem;
}

.table-container .data-row td {
  padding: 0.5rem;
  border-bottom: 1px solid #dee2e6;
}

.table-container .data-row:last-child td {
  border-bottom: none;
}

.edtiable-table-row{
    animation-name: edtiable-table-row;
    animation-duration: 2s;
    animation-iteration-count: infinite;
}
@keyframes edtiable-table-row {
    0% {
        background-color: #dbf7ff;
      }
      50% {
        background-color: #d0eaffde;
      }
      100% {
        background-color: #dbf7ff;
      }
    }
</style>